import { MutableRefObject } from 'react'
import { blocknoteSchema } from '../blocknoteSchema'

/**
 * Checks if there's more than one phase block in a BlockNote document, and if there is,
 * filters out the newer phase block. Intended to be called in Blocknotes' onChange handler.
 *
 * @param previousBlockNoteDocument previous blocknote document state
 * @param blocknoteEditor blocknote editor instance
 * @returns void
 */
export const limitPhaseBlockCount = ({
  previousBlockNoteDocument,
  blockNoteEditor
}: {
  previousBlockNoteDocument: MutableRefObject<
    (typeof blocknoteSchema.BlockNoteEditor)['document']
  >
  blockNoteEditor: typeof blocknoteSchema.BlockNoteEditor
}) => {
  const existingPhaseBlock = previousBlockNoteDocument.current.find(
    block => block.type === 'phases'
  )

  const currentPhaseBlocks = blockNoteEditor.document.filter(
    block => block.type === 'phases'
  )

  if (existingPhaseBlock && currentPhaseBlocks.length > 1) {
    const deletePhaseBlock = blockNoteEditor.document.find(
      block => block.type === 'phases' && block.id !== existingPhaseBlock.id
    )

    if (!deletePhaseBlock) return

    blockNoteEditor.removeBlocks([deletePhaseBlock])
  }
}
